import React, { useRef } from "react";
import generatePDF from "react-to-pdf";
import { TermsAndConditionsPDF } from "./termsForPDF";
import { TermsAndConditionsSubsPDF } from "./subsTerms";

const UnauthPDF = ({
  name,
  email,
  termsAccepted,
  signature,
  ipAddress,
  timestamp,
}) => {
  const pdfRef = useRef();

  return (
    <div className="pdfMain">
      <div
        ref={pdfRef}
        style={{
          position: "absolute",
          left: "-9999px",
          top: "-9999px",
          width: "210mm", // A4 width for better formatting
          color: "black",
          padding: 20,
          backgroundColor: "#fff",
          pageBreakAfter: "always",
        }}
      >
        <h3>
          Data Disclosure, Legal Action Policy & Unauthorized Transaction
          Summary
        </h3>
        <p>
          <strong>Name:</strong> {name}
        </p>
        <p>
          <strong>Email:</strong> {email}
        </p>
        <p>
          <strong>Terms Accepted:</strong> {termsAccepted ? "Yes" : "No"}
        </p>
        {ipAddress && (
          <p>
            <strong>Ip Address:</strong> {ipAddress}
          </p>
        )}
        <p>
          <strong>Timestamp:</strong> {timestamp}
        </p>
        <div className="">
          <div className="termsPage">
            <h1>TERMS & CONDITIONS ACCEPTED BY SUBSCRIBER</h1>

            <p className="mb-3">
              If any unauthorized, fraudulent, or suspicious payment activity is
              detected on WaqarZaka.net, the platform reserves the right to
              investigate and take all necessary actions to protect its users
              and business
            </p>

            <p className="mb-3">
              This includes — but is not limited to — the disclosure of
              information such as your name, contact details, login credentials,
              IP address, and payment data to law enforcement agencies,
              financial institutions, and relevant authorities for the purpose
              of fraud prevention, investigation, and prosecution.
            </p>
            <p className="mb-3">
              All disclosures will be made only as necessary and in full
              compliance with applicable data-protection and privacy laws
              (including GDPR, CCPA, and similar global regulations).
              WaqarZaka.net will never sell or disclose your information for
              profit, and maintains strict technical and organizational
              safeguards to protect user data.
            </p>
            <p className="mb-3">
              In cases of unauthorized use of payment methods, stolen cards, or
              fraudulent activity, WaqarZaka.net and its legal team reserve the
              right to initiate legal proceedings or file a case against the
              responsible party, either directly or through authorized
              representatives, in accordance with local and international law
            </p>
            <p className="mb-3">
              By using this platform, you acknowledge and consent to these terms
              and understand that any unauthorized transaction constitutes a
              criminal and civil violation, which may result in account
              suspension, permanent ban, and legal action.
            </p>
          </div>
        </div>{" "}
      </div>
      <button
        onClick={() =>
          generatePDF(pdfRef, { filename: `subs-consent(${email}).pdf` })
        }
      >
        Download PDF
      </button>
    </div>
  );
};

export default UnauthPDF;
